import { Can } from 'providers/casl'
import { onAbTestsAccess, onAbTestsCreateUpdateDelete } from '../features/abTests'
import {
  onAdUnitAccess,
  onAdUnitMediaTypesCUD,
  onAdUnitUnfilledRecoveryBasicSettingsUpdate,
  onAdUnitUnfilledRecoveryMultiFormatsUpdate,
  onAdUnitYbAdUnitEnabledCreateUpdate,
} from '../features/adUnit'
import {
  onDomainAccess,
  onDomainAdvancedSettingsUpdate,
  onDomainBulkManagementCreate,
  onDomainCreateUpdateDelete,
  onDomainOverridenByYieldbirdRead,
  onDomainOverridenByYieldbirdUpdate,
  onDomainRichPlacementsFeatureMultiAnchorAdUnitConnectionUpdate,
  onDomainRichPlacementsFrequencyCappingUpdate,
  onDomainRichPlacementsMultiAnchorAccess,
  onDomainUnfilledRecoveryBaseAdUnitPathUpdate,
} from '../features/domain'
import { onFinanceAccess } from '../features/finance'
import {
  onGlobalSetupAmazonAccess,
  onGlobalSetupAmazonUpdate,
} from '../features/globalSetup/amazon'
import {
  onGlobalSetupAccess,
  onGlobalSetupPriceGeniusUpdate,
  onGlobalSetupWorkspaceUserACUD,
} from '../features/globalSetup/common'
import {
  onGlobalSetupDefaultsPrebidStackAccess,
  onGlobalSetupDefaultsPrebidStackUpdate,
  onGlobalSetupDefaultsPrebidVariableNameUpdate,
  onGlobalSetupDefaultsRichPlacementsAccess,
  onGlobalSetupDefaultsRichPlacementsFrequencyCappingUpdate,
  onGlobalSetupDefaultsRichPlacementsUpdate,
} from '../features/globalSetup/defaults'
import {
  onGlobalSetupGoogleAdManagerConnectionAccess,
  onGlobalSetupGoogleAdManagerConnectionUpdate,
  onGlobalSetupGoogleAdManagerSetupRetargetingDeliveryItemsReadUpdate,
} from '../features/globalSetup/googleAccountManagerConnection'
import {
  onGlobalSetupBiddersBidParamsCommonUpdate,
  onGlobalSetupBiddersBidParamsOwnUpdate,
  onGlobalSetupBiddersBidParamsThirdPartyProviderUpdate,
  onGlobalSetupBiddersBidParamsYieldbirdUpdate,
  onGlobalSetupBiddersCUD,
  onGlobalSetupBiddersOwnUpdate,
  onGlobalSetupBiddersThirdPartyUpdate,
  onGlobalSetupBiddersYieldbirdCpmConsentStatusUpdate,
  onGlobalSetupBiddersYieldbirdUpdate,
  onGlobalSetupPrebidBiddersAccess,
  onGlobalSetupPrebidBiddersAddaccess,
  onGlobalSetupPrebidModuleAccess,
  onGlobalSetupPrebidModuleCUD,
  onGlobalSetupPrebidModulesGeneralParamsOwnUpdate,
  onGlobalSetupPrebidModulesGeneralParamsYieldbirdUpdate,
  onGlobalSetupPrebidModulesInventoryConnectionParamsOwnRead,
  onGlobalSetupPrebidModulesInventoryConnectionParamsOwnUpdate,
  onGlobalSetupPrebidModulesInventoryConnectionParamsYieldbirdRead,
  onGlobalSetupPrebidModulesInventoryConnectionParamsYieldbirdUpdate,
  onGlobalSetupPrebidModuleStatusUpdate,
  onGlobalSetupPrebidProtectionAccess,
  onGlobalSetupProtectionACUD,
} from '../features/globalSetup/prebid'
import {
  onGlobalSetupSupplyChainAccess,
  onGlobalSetupSupplyChainAddAccess,
  onGlobalSetupSupplyChainCUD,
} from '../features/globalSetup/supplyChain'
import { onViewportCUD } from '../features/globalSetup/viewport'
import { onHistoryAccess } from '../features/history'
import {
  onGamAccountSidebarItemAccess,
  onHelpMenuItemAccess,
  onLayoutAccess,
} from '../features/layout'
import { onPageAccess, onPageAddAccess, onPageCreateUpdateDelete } from '../features/page'
import {
  onPerformanceAllProductAccess,
  onPerformanceDataSamplingReadUpdate,
  onPerformanceGeneralAccess,
} from '../features/performance'
import { onPortalAccess } from '../features/portal'
import { onProductAccess } from '../features/product'
import { onTagAccess } from '../features/tag'
import { onUserPagePublisherACUD } from '../features/user'

export const onCustomerPerformance = (can: Can) => {
  onAbTestsAccess(can)
  onAbTestsCreateUpdateDelete(can)
  onAdUnitAccess(can)
  onAdUnitMediaTypesCUD(can)
  onAdUnitUnfilledRecoveryBasicSettingsUpdate(can)
  onAdUnitUnfilledRecoveryMultiFormatsUpdate(can)
  onAdUnitYbAdUnitEnabledCreateUpdate(can)
  onDomainAccess(can)
  onDomainAdvancedSettingsUpdate(can)
  onDomainBulkManagementCreate(can)
  onDomainCreateUpdateDelete(can)
  onDomainOverridenByYieldbirdRead(can)
  onDomainOverridenByYieldbirdUpdate(can)
  onDomainRichPlacementsFeatureMultiAnchorAdUnitConnectionUpdate(can)
  onDomainRichPlacementsFrequencyCappingUpdate(can)
  onDomainRichPlacementsMultiAnchorAccess(can)
  onDomainUnfilledRecoveryBaseAdUnitPathUpdate(can)
  onFinanceAccess(can)
  onGamAccountSidebarItemAccess(can)
  onGlobalSetupAccess(can)
  onGlobalSetupAmazonAccess(can)
  onGlobalSetupAmazonUpdate(can)
  onGlobalSetupBiddersBidParamsCommonUpdate(can)
  onGlobalSetupBiddersBidParamsOwnUpdate(can)
  onGlobalSetupBiddersBidParamsThirdPartyProviderUpdate(can)
  onGlobalSetupBiddersBidParamsYieldbirdUpdate(can)
  onGlobalSetupBiddersCUD(can)
  onGlobalSetupBiddersOwnUpdate(can)
  onGlobalSetupBiddersThirdPartyUpdate(can)
  onGlobalSetupBiddersYieldbirdCpmConsentStatusUpdate(can)
  onGlobalSetupBiddersYieldbirdUpdate(can)
  onGlobalSetupDefaultsPrebidStackAccess(can)
  onGlobalSetupDefaultsPrebidStackUpdate(can)
  onGlobalSetupDefaultsPrebidVariableNameUpdate(can)
  onGlobalSetupDefaultsRichPlacementsAccess(can)
  onGlobalSetupDefaultsRichPlacementsFrequencyCappingUpdate(can)
  onGlobalSetupDefaultsRichPlacementsUpdate(can)
  onGlobalSetupGoogleAdManagerConnectionAccess(can)
  onGlobalSetupGoogleAdManagerConnectionUpdate(can)
  onGlobalSetupGoogleAdManagerSetupRetargetingDeliveryItemsReadUpdate(can)
  onGlobalSetupPrebidBiddersAccess(can)
  onGlobalSetupPrebidBiddersAddaccess(can)
  onGlobalSetupPrebidModuleAccess(can)
  onGlobalSetupPrebidModuleCUD(can)
  onGlobalSetupPrebidModulesGeneralParamsOwnUpdate(can)
  onGlobalSetupPrebidModulesGeneralParamsYieldbirdUpdate(can)
  onGlobalSetupPrebidModulesInventoryConnectionParamsOwnRead(can)
  onGlobalSetupPrebidModulesInventoryConnectionParamsOwnUpdate(can)
  onGlobalSetupPrebidModulesInventoryConnectionParamsYieldbirdRead(can)
  onGlobalSetupPrebidModulesInventoryConnectionParamsYieldbirdUpdate(can)
  onGlobalSetupPrebidModuleStatusUpdate(can)
  onGlobalSetupPrebidProtectionAccess(can)
  onGlobalSetupPriceGeniusUpdate(can)
  onGlobalSetupProtectionACUD(can)
  onGlobalSetupSupplyChainAccess(can)
  onGlobalSetupSupplyChainAddAccess(can)
  onGlobalSetupSupplyChainCUD(can)
  onGlobalSetupWorkspaceUserACUD(can)
  onHelpMenuItemAccess(can)
  onHistoryAccess(can)
  onLayoutAccess(can)
  onPageAccess(can)
  onPageAddAccess(can)
  onPageCreateUpdateDelete(can)
  onPerformanceAllProductAccess(can)
  onPerformanceDataSamplingReadUpdate(can)
  onPerformanceGeneralAccess(can)
  onPortalAccess(can)
  onProductAccess(can)
  onTagAccess(can)
  onUserPagePublisherACUD(can)
  onViewportCUD(can)
}
